import { Injectable } from '@angular/core';
import { API_URL } from '../../../../../services/config';
import { LoadIdView } from '../../../../models';
import { ShipmentLoadEndpoint } from '../../constants';
import { ShipmentLoadTransportOrderModel } from '../../models';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { getQueryStringFromObject } from '../../../../../common/utils';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShipmentLoadTransportOrdersService {
  constructor(private http: WrapperHttpService) {}

  getShipmentLoadTransportOrders(params: LoadIdView): Observable<ShipmentLoadTransportOrderModel[]> {
    return this.http
      .withLoading()
      .get<ShipmentLoadTransportOrderModel[]>(
        `${API_URL}${ShipmentLoadEndpoint.Base}${ShipmentLoadEndpoint.Loads}${
          ShipmentLoadEndpoint.TransportOrders
        }?${getQueryStringFromObject(params)}`,
      );
  }
}
